import BaseVueComponent from "common/BaseVueComponent"
import ViewerJs from "viewerjs"
import { Component, Prop } from "vue-property-decorator"
@Component
export default class AttachmentsViewerImageBase extends BaseVueComponent {
    @Prop({ default: true }) public src!: string

    public viewer: ViewerJs | null = null
    mounted(): void {
        // NOTE a ref, not a page-wide id - several viewers can be on the page at once (e.g. the hub logo and the
        // company logo dialog), and an id lookup would bind this one's full screen to another viewer's image
        const imageViewer = this.$refs.fullScreenImage as HTMLImageElement | undefined

        if (imageViewer) {
            this.viewer = new ViewerJs(imageViewer, {
                toolbar: {
                    zoomIn: 4,
                    zoomOut: 4,
                    oneToOne: 4,
                    reset: 4,
                    rotateLeft: 4,
                    rotateRight: 4,
                    flipHorizontal: 4,
                    flipVertical: 4
                }
            })
        }
    }

    beforeDestroy(): void {
        // NOTE viewerjs puts its full screen overlay on <body>, so it outlives this component unless destroyed here
        this.closeFullScreen()
    }
    public viewFullScreen(): void {
        if (!this.viewer) return
        this.viewer.show()
    }
    public closeFullScreen(): void {
        if (this.viewer) this.viewer.destroy()
    }
}
